import { SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT } from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const StyledKeyFactsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const DriveTrainKeyfactStyle = styled.div`
	display: flex;
	flex-direction: column-reverse;
	p:first-of-type {
		&,
		sup {
			color: ${SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT};
		}
	}
`;
